import {
	LOGIN,
	LOGOUT,
	GET_AUTH_PERMISSIONS,
	CHANGE_SITE
} from '../Actions/types';

const initSate = {
	user: (localStorage.user) ? JSON.parse(localStorage.user) : null,
	permissions: [],
};

const AuthReducer = (state = initSate, action) => {

	switch (action.type) {

		case LOGIN: {
			
			let user = { ...action.payload, accessToken: action.payload.token };
			localStorage.user = JSON.stringify(user);
			return { ...state, user: user };
		}


		case CHANGE_SITE: {
			
			let user = { ...action.payload, accessToken: action.payload.token };
			localStorage.user = JSON.stringify(user);
			
			return { ...state, user };
		}
		

		case LOGOUT: {
			localStorage.user = null;
			return { ...state, user: null, permissions: [] };
		}

		case GET_AUTH_PERMISSIONS: {
			const permissions = action.payload;
			const { user } = state;
			user.permissions = permissions;
			return { ...state, permissions, user };
		}

	}
	return state;
};

export default AuthReducer;
